import { defineComponent as _defineComponent } from 'vue'
import StreamGreenSection from './StreamGreenSection.vue';
import type { FootprintParams } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamGreenUpload',
  emits: ["next"],
  setup(__props, { emit: emits }: { emit: ({ (e: 'next', params: FootprintParams): void }), expose: any, slots: any, attrs: any }) {



const watchHistoryTutorialGif = `/${ASSETS_DIR}/img/stream-green/tutorial_screenshots/watchhistory_tutorial.gif`;

async function openFile(input: any) {
	try {
		// decide on last year date
		const now = new Date();
		const lastYear = new Date(now);
		lastYear.setDate(now.getDate() - 365);
		// read csv into raw string
		const content = await readFile(input.files[0]);
		const lines = content.split('\n');
		// check if it's a valid Netflix WatchHistory csv
		if (lines.slice(0, 1).join('\n') !== 'Title,Date') {
			throw new Error('Invalid file!');
		}

		const list = CSVToArray(
			// drop first line
			lines.slice(1).join('\n')
		).filter((items: string | any[]) => items.length === 2);

		const history = list
			.filter(item => item[0] != null)
			.map(item => ({
				title: item[0],
				type: isMovieTitle(item[0]) ? 'movie' : 'show',
				date: new Date(item[1].replace(/(\d{2}).(\d{2}).(\d{2,4})/, '$2/$1/$3')).getTime(),
			}));

		const yearlyKwh =
			history.reduce((root, item) => {
				const kwh = item.type === 'movie' ? 95 / 60 : 45 / 60;
				return root + kwh * 0.74;
			}, 0) * 463;

		const amounts = history.reduce(
			(root, item) => {
				if (item.type === 'movie') {
					root.movies++;
				}
				if (item.type === 'show') {
					root.episodes++;
				}
				return root;
			},
			{ episodes: 0, movies: 0 }
		);

		const params: FootprintParams = {
			yearlyKwh,
			selectedProviders: ['netflix'],
			amountEpisodes: amounts.episodes,
			amountMovies: amounts.movies,
			startDatetime: history.length > 0 ? history[history.length - 1].date : 0,
		};
		emits('next', params);
	} catch (err) {
		window.alert(`${err}`);
	}
}

function readFile(file: any): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve(reader.result as string);
		};
		reader.onerror = () => reject(new Error('[StreamGreenUpload]: Error reading file', { cause: reader.error }));
		reader.readAsText(file);
	});
}

function isMovieTitle(title: string) {
	return !(title.includes(': Season ') || title.includes(': Staffel '));
}

// source: https://www.bennadel.com/blog/1504-ask-ben-parsing-csv-strings-with-javascript-exec-regular-expression-command.htm
function CSVToArray(strData: string, strDelimiter = ',') {
	const objPattern = new RegExp(
		// Delimiters.
		'(\\' +
			strDelimiter +
			'|\\r?\\n|\\r|^)' +
			// Quoted fields.
			'(?:"([^"]*(?:""[^"]*)*)"|' +
			// Standard fields.
			'([^"\\' +
			strDelimiter +
			'\\r\\n]*))',
		'gi'
	);
	const arrData = [[]] as string[][];
	let arrMatches = null;
	while ((arrMatches = objPattern.exec(strData))) {
		const strMatchedDelimiter = arrMatches[1];
		if (strMatchedDelimiter.length && strMatchedDelimiter != strDelimiter) {
			arrData.push([]);
		}
		if (arrMatches[2]) {
			var strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"');
		} else {
			var strMatchedValue = arrMatches[3];
		}
		arrData[arrData.length - 1].push(strMatchedValue);
	}
	return arrData;
}

return { __sfc: true,emits, watchHistoryTutorialGif, openFile, readFile, isMovieTitle, CSVToArray, StreamGreenSection }
}

})